import { motion } from "framer-motion";
import { MessageCircle, Rocket } from "lucide-react";
import { waLink, WA_DEFAULT_MESSAGE } from "../config";

export const MobileBar = () => (
    <motion.div
        data-testid="mobile-action-bar"
        initial={{ y: 90 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.7, delay: 1.2, ease: [0.16, 1, 0.3, 1] }}
        className="md:hidden fixed bottom-0 inset-x-0 z-50 glass border-t border-slate-200/80 px-4 pt-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]"
    >
        <div className="grid grid-cols-2 gap-3">
            <a
                href={waLink(WA_DEFAULT_MESSAGE)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="mobile-bar-whatsapp"
                className="inline-flex items-center justify-center gap-2 py-3.5 rounded-full text-sm font-bold text-white bg-[#25D366] shadow-lg shadow-emerald-500/25"
            >
                <MessageCircle className="h-5 w-5" />
                WhatsApp
            </a>
            <a
                href="#progetti"
                data-testid="mobile-bar-projects"
                className="inline-flex items-center justify-center gap-2 py-3.5 rounded-full text-sm font-bold text-white bg-[#03045E] shadow-lg shadow-sky-950/25"
            >
                <Rocket className="h-5 w-5" />
                I miei progetti
            </a>
        </div>
    </motion.div>
);
